import { DATE_CONTEXTS, dateContextLabel } from '../../lib/dateContext';

/**
 * "· DOB" after a date's type label: why the date matters (sc-11466). Renders
 * nothing for an untagged date or one with no protected context.
 */
export function DateContextTag({ tag, className }: { tag?: string | null; className?: string }) {
  const label = dateContextLabel(tag);
  if (!label || !tag) return null;
  return (
    <span data-testid="date-context-tag" className={className} title={DATE_CONTEXTS[tag]?.description}>
      {/* Non-breaking: a flex parent would drop a leading plain space. */}
      {'\u00a0·\u00a0'}
      {label}
    </span>
  );
}
